import { createContext, useState } from "react";
import { useDispatch } from "react-redux";
import { isEmpty } from "lodash";

import {
  runShellStatisticsService,
  getServicesService,
  getEmployersService,
} from "./../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import { toastErrorMessage } from "../../../utils/toastMessage/toastMessage";

export const statisticAdminContext = createContext({
  statistics: [],
  setStatistics: () => {},
  dateType: "",
  setDateType: () => {},
  isNot_in: null,
  setIsNot_in: () => {},
  table: null,
  setTable: () => {},
  limit: null,
  setLimit: () => {},
  fromDate: "",
  setFromDate: () => {},
  toDate: "",
  setToDate: () => {},
  mobile_verified: null,
  setMobile_verified: () => {},
  services: [],
  setServices: () => {},
  order_status: null,
  employers: [],
  setEmployers: () => {},
  employer: "",
  setEmployer: () => {},
  setOrder_status: () => {},
  handleGetStatistics: () => {},
  handleGetServices: () => {},
  handleGetEmployers: () => {},
});

const StatisticAdminContext = ({ children }) => {
  // Redux Dispatch
  const dispatch = useDispatch();

  const [statistics, setStatistics] = useState([]);
  const [mobile_verified, setMobile_verified] = useState("0");
  const [order_status, setOrder_status] = useState(false);
  const [table, setTable] = useState(0);
  const [dateType, setDateType] = useState(0);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [limit, setLimit] = useState(0);
  const [isNot_in, setIsNot_in] = useState(false);
  const [services, setServices] = useState([]);
  const [employers, setEmployers] = useState([]);
  const [employer, setEmployer] = useState("");

  // Handle Get Statistics Method
  const handleGetStatistics = async (event) => {
    event?.preventDefault();

    const fromDateVal = isEmpty(fromDate) ? null : fromDate?.split("T")[0];
    const toDateVal = isEmpty(toDate) ? null : toDate?.split("T")[0];

    const objData = {
      unique_id: services[table].unique_id,
      interval: "DAY",
      from_limit: dateType === 1 ? `${fromDateVal} 00:00:00` : "0",
      from_duration: dateType === 2 ? `${fromDateVal} 00:00:00` : "0",
      to_duration: dateType === 2 ? `${toDateVal} 23:59:59` : "0",
      limit: dateType === 3 ? limit : 0,
      not_in: isNot_in ? "not" : "",
      mobile_verified,
      order_status,
      ...(employer && { client_type: employer === "null" ? null : employer }),
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await runShellStatisticsService(objData);
      if (status === 200) {
        setStatistics(data);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Get Services Method
  const handleGetServices = async (event) => {
    event?.preventDefault();
    const objData = {
      search: "",
      offset: 0,
      limit: 300,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getServicesService(objData);
      if (status === 200) {
        data.list.splice(0, 0, {
          id: 1000000,
          name: "همه",
          unique_id: "%",
          icon: "",
        });
        setServices(data.list);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Get Employers Method
  const handleGetEmployers = async () => {
    try {
      const { status, data } = await getEmployersService();
      if (status === 200) {
        setEmployers(data.list);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    }
  };

  return (
    <statisticAdminContext.Provider
      value={{
        statistics,
        setStatistics,
        dateType,
        setDateType,
        isNot_in,
        setIsNot_in,
        table,
        setTable,
        limit,
        setLimit,
        fromDate,
        setFromDate,
        toDate,
        setToDate,
        mobile_verified,
        setMobile_verified,
        services,
        setServices,
        order_status,
        employers,
        setEmployers,
        setOrder_status,
        employer,
        setEmployer,
        handleGetStatistics,
        handleGetServices,
        handleGetEmployers,
      }}
    >
      {children}
    </statisticAdminContext.Provider>
  );
};

export default StatisticAdminContext;
